import { render, staticRenderFns } from "./ShiftSummaryTable.vue?vue&type=template&id=53547b54&"
import script from "./ShiftSummaryTable.vue?vue&type=script&lang=js&"
export * from "./ShiftSummaryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports